<template>
    <LayoutWithContainer :small="true">
        <div v-if="$wait.is('fetching preview resource')" class="loading">
            <Spinner :height="40" :width="40" />
        </div>
        <template v-else>
            <template slot="header">
                <ContentHeader title="Notifications" :bordered="false">
                    <template slot="custom-back">
                        <a href="#" @click.prevent.stop="$router.go(-1)" style="margin-bottom: .5rem">Go Back</a>
                    </template>
                </ContentHeader>
            </template>
            <div class="notifications-container">
                <header class="notifications-container__header">
                    <h3>Your Notifications</h3>
                    <a href="#" v-show="resource && resource.length > 0" @click.prevent.stop="handleClearAll">Clear All</a>
                </header>
                <ul class="notifications-list">
                    <li v-for="notification in resource" :class="{ 'is-read': notification.read }">
                        <button class="notification-detail" @click.prevent.stop="handleNotificationClicked(notification)">
                            <span class="notification-detail__message" v-html="notification.message" />
                            <span class="notification-detail__avatars">
                                <img
                                    v-for="user in notification.related_users.slice(0, 3)"
                                    :src="user.avatar ? user.avatar.url : '//placehold.it/32x32'"
                                    :alt="`Profile Image for ${user.name}`"
                                />
                            </span>
                            <span class="notification-detail__date" v-text="notification.date_formatted"/>
                        </button>
                        <button class="clear-notification" type="button" @click.prevent.stop="handleClear(notification.id)">
                            ✕
                        </button>
                    </li>
                </ul>
            </div>
        </template>
    </LayoutWithContainer>
</template>
<script>

import ContentHeader from '@components/Header/ContentHeader';
import HeaderSearch from '@components/Header/HeaderSearch';
import Notifications from '@components/Header/Notifications';
import ResourcePreview from '@components/ResourcePreview';
import API from '@api';
import LayoutWithContainer from '@layouts/LayoutWithContainer.vue';
import Spinner from '@components/Spinner.vue';

export default {
    name: "NotificationsView",
    mixins: [ ResourcePreview ],
    components: {
        Spinner,
        LayoutWithContainer,
        Notifications,
        HeaderSearch,
        ContentHeader
    },
    data() {
        return {
            resource: null,
        }
    },
    methods: {
        async fetchResource() {
            try {
                return await API.getNotifications({ per_page : 100 });
            } catch(err) {
                console.warn({err});
            }
        },
        handleClear: async function(notificationId) {
            try {
                this.resource = this.resource.filter((notif) => notif.id !== notificationId);
                await API.clearNotification(notificationId);
            } catch(err) {
                console.log({err});
                console.warn('Failed to clear notification');
            } finally {
                this.fetchResource();
            }
        },
        handleClearAll: async function() {
            try {
                this.resource = null;
                await API.clearAllNotifications();
            } catch(err) {
                console.warn('Failed to clear notifications');
            } finally {
                this.getNotifications(false);
            }
        },
        handleNotificationClicked: function(notification){
            API.readNotification(notification.id);
            this.$router.push(notification.url);
        },
    }
}

</script>
<style lang="scss">
@import '~@/theme/_variables.scss';

.notifications-container {
    flex-direction: column;
    border-radius: .6rem;
    max-width: calc(100vw - 4rem);
    color: black;
    background-color: white;
    box-shadow: 0 .6rem 2rem 0 rgba(49, 49, 74, 0.16);
    overflow: hidden;

    .notifications-container__header {
        padding: 1.6rem 1.5rem 1.4rem 1.5rem;
        display: flex;
        align-items: center;
        border-bottom: .1rem solid $border;

        h3 {
            margin-bottom: 0;
        }

        a {
            margin-left: auto;
            margin-right: 0;
        }
    }
}

.notifications-list {
    margin: 0;
    list-style: none;
    padding: 0;

    li {
        background-color: rgba(190, 33, 67, 0.08);
        display: flex;
        align-items: center;
        column-gap: 1rem;

        .notification-detail {
            flex-grow: 1;
        }

        .clear-notification {
            height: 100%;
            padding: 1.5rem 1.5rem 1.5rem 0;
        }

        &.is-read {
            background-color: white;
        }

        + li {
            border-top: .1rem solid white;
        }
    }
}

.notification-detail {
    appearance: none;
    -webkit-appearance: none;
    border: none;
    padding: 1.5rem 0 1.5rem 1.5rem;
    display: flex;
    align-items: center;
    column-gap: 1rem;
    background-color: transparent;
    font-family: "Axiforma", sans-serif;

    .notification-detail__avatars {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        flex: 0 0 6rem;

        img {
            border-radius: 50%;
            height: 3rem;
            width: 3rem;
            position: relative;

            &:nth-child(1) {
                z-index: 3;
            }

            &:nth-child(2) {
                z-index: 2;
            }

            &:nth-child(3) {
                z-index: 1;
            }

            + img {
                margin-left: -1.5rem;
            }
        }
    }

    .notification-detail__message {
        font-size: 1.4rem;
        line-height: 1.7rem;
        color: black;
        white-space: nowrap;
        overflow: hidden;
        flex: 1 1 auto;
        text-overflow: ellipsis;
        max-width: 51.2rem;
        text-align: left;
    }

    .notification-detail__date {
        flex: 0 0 6.3rem;
        text-align: right;
        color: $text;
    }
}

.clear-notification {
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: $text;
}
</style>
